import { Component, OnDestroy, OnInit } from '@angular/core';
import { KPI } from '../../../../@core/api';
import { ChartFiltersService, UsersService } from '../../../../@core/utils';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { NbRadioModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { GROUP_PERMISSION_EDIT_ENERGY_SETTINGS } from '../../../../@core/api/models';
import { AsyncPipe } from '@angular/common';

export const CONSUMPTION_TYPE_FILTER_OPTIONS = [
  {
    value: KPI.ConsumptionType.RAW_CONSUMPTION,
    label: _('From raw kWh consumptions'),
  },
  {
    value: KPI.ConsumptionType.CONSUMPTION_CORRECTED_CLIMATE,
    label: _('From kWH consumption corrected for seasonal variations & uses'),
  },
  {
    value: KPI.ConsumptionType.CONSUMPTION_CORRECTED_OFFICIAL,
    label: _('From other corrected kWH consumption'),
  },
];

@Component({
  selector: 'app-consumption-type-filter',
  templateUrl: './consumption-type-filter.component.html',
  styleUrls: ['./consumption-type-filter.component.scss'],
  standalone: true,
  imports: [
    NbRadioModule,
    TranslateModule,
    FormsModule,
    AsyncPipe,
  ],
})
export class ConsumptionTypeFilterComponent implements OnInit, OnDestroy {

  public energyConsumptionType: string;
  public carbonConsumptionType: string;

  public options = CONSUMPTION_TYPE_FILTER_OPTIONS;

  public canEdit$: Observable<boolean> = this.usersService.hasCurrentUserPermissions([GROUP_PERMISSION_EDIT_ENERGY_SETTINGS]);

  private subscriptions: Subscription[] = [];

  constructor(
    private chartFiltersService: ChartFiltersService,
    private usersService: UsersService,
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      combineLatest([
        this.chartFiltersService.filter$('energyConsumptionType', false),
        this.chartFiltersService.filter$('carbonConsumptionType', false),
      ]).subscribe(([energyConsumptionType, carbonConsumptionType]) => {
        this.energyConsumptionType = <string>energyConsumptionType;
        this.carbonConsumptionType = <string>carbonConsumptionType;
      }),
    );
  }

  public filterChanged(energyOrCarbon: 'energy' | 'carbon'): void {
    setTimeout(() => {
      if (energyOrCarbon === 'energy') {
        this.chartFiltersService.setFilter('energyConsumptionType', this.energyConsumptionType);
      } else if (energyOrCarbon === 'carbon') {
        this.chartFiltersService.setFilter('carbonConsumptionType', this.carbonConsumptionType);
      }
    }, 50);
  }



  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
